module.exports = __webpack_public_path__ + "static/img/3324_phase_function_Paper_Points.a8ff128.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3324_phase_function_Paper_Points.png
// module id = u2/A
// module chunks = 0